import * as types from "../constants";

const initialState = {
  isLoading: false,
  error: null,
  items: [],
};

export default function fundDistributionWatchGetCountriesForRegionEditReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_FUND_DISTRIBUTION_WATCH_GET_COUNTRIES_FOR_REGION_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_FUND_DISTRIBUTION_WATCH_GET_COUNTRIES_FOR_REGION_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_FUND_DISTRIBUTION_WATCH_GET_COUNTRIES_FOR_REGION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
